import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Grid, TableCell, TableRow } from "@mui/material";
import { Colors } from "../../constants/Colors";
import Card from "../../components/Card";
import CustomTable from "../../components/Table";
import CustomButton from "../../components/Button";
import CustomModal from "../../components/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "../../services/api-request";
import { useAppContext } from "../../context/AppContext";
import Pagination from "../../components/Pagination";
import { ConvertMonthsToYearsMonthsDays } from "../../utilities/date-utility";
import { downloadFile, escapeCSVField } from "../../utilities/exportToCsv";
import CustomCircularProgress from "../../components/CircularProgress";
import styles from "./animal-list.module.css";
import { Capitalize } from "../../utilities/constants";
import CustomDialog from "../../components/ConfirmationModal";
import AddAnimal from "./add-animal";
import _ from "underscore";
import {
  CSelect,
  CInput
} from '@coreui/react'

const dashboardHeader = [
  {
    id: 1,
    title: "S.No",
  },
  {
    id: 2,
    title: "ID",
  },

  {
    id: 3,
    title: "Animal Basic Info",
  },
  {
    id: 4,
    title: "Animal Location",
  },
  {
    id: 5,
    title: "Customer",
  },
  {
    id: 6,
    title: "Branch Info",
  },
  // {
  //   id: 6,
  //   title: "VE",
  // },
  // {
  //   id: 7,
  //   title: "Status",
  // },
  // {
  //   id: 8,
  //   title: "Certified",
  // },
  // {
  //   id: 9,
  //   title: "Market Place",
  // },
  // {
  //   id: 10,
  //   title: "Action",
  // },
];

const Muzzle = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [openUserModal, setOpenUserModal] = useState({
    open: false,
    data: [],
  });
  const [data, setData] = useState([])
  const [ind, setInd] = useState(0)
  const { user = {} } = useAppContext();
  const [userAnimals, setUserAnimals] = useState({});
  const [currentAnitraUserState, setCurrentAnitraUserState] = useState({});
  const role = "Muzzle Animals"
  const roleSingular = "Muzzle Animals"
  const currentRole = user?.role?.code || null;
  const branch_id = user?.role?.branch_id || null;

  const [openAceRequestModal, setOpenAceRequestModal] = useState({
    data: {},
    open: false,
  });
  const [openViewImageModal, setOpenViewImageModal] = useState({
    images: [],
    open: false,
  });

  const location = useLocation();

  const [userAnimalsCSV, setUserAnimalsCSV] = useState({
    data: [],
    loader: false,
  });

  const limit = 10;
  const [skip, setSkip] = useState(0);


  const [filters, setFilters] = useState({
      state_id: "",
      circle_id: "",
      regional_id: "",
      branch_id: "",
  });

  const [statesList, setStatesList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [regionalList, setRegionalList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
        getStates();
  }, []);

  const getStates = () => {
      apiRequest({
        url: `master/states`,
        method: "GET",
      })
      .then((res) => {
          setStatesList(res?.data);
      })
        .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
      if (filters.state_id) {
          getCirlces(filters.state_id);
      }
  }, [filters.state_id]);

  const getCirlces = (state_id) => {
      apiRequest({
        url: "bank/get-circle-office?state_id="+state_id,
        method: "GET",
      })
      .then((res) => {
          setCircleList(res?.data);
          setFilters(prev => ({
              ...prev,
              circle_id: "",
              regional_id: "",
              branch_id: "",
          }));
      })
      .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
      if (filters.circle_id) {
        getRegionals(filters.circle_id);
      }
  }, [filters.circle_id]);

  const getRegionals = (circle_id) => {
      apiRequest({
        url: "bank/get-regional-office?circle_id="+circle_id,
        method: "GET",
      })
      .then((res) => {
          setRegionalList(res?.data);
          setFilters(prev => ({
              ...prev,
              regional_id: "",
              branch_id: "",
          }));
      })
      .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  useEffect(() => {
      if (filters.regional_id) {
        getBranches(filters.regional_id);
      }
  }, [filters.regional_id]);

  const getBranches = (regional_id) => {
      apiRequest({
        url: "bank/get-branch?regional_id="+regional_id,
        method: "GET",
      })
      .then((res) => {
          setBranchList(res?.data);
          setFilters(prev => ({
              ...prev,
              branch_id: ""
          }));
      })
      .catch((err) => {
          alert(err?.response?.data?.message, "error");
      });
  };

  const handleChange = (field) => (e) => {
      const value = e.target.value;
      setFilters(prev => ({
          ...prev,
          [field]: value
      }));
  };


  useEffect(() => {
    getUserAnimals(filters);
  }, [filters, skip]);

  const getUserAnimals = (filters) => {
    const payload = {
      skip: skip,
      limit: limit,
      currentRole: currentRole,
      branch_id: branch_id,
      ...(filters.search && {
        searchText: filters?.search,
      }),
      ...(filters.state_id && {
        filter_state_id: filters.state_id,
      }),
      ...(filters.circle_id && {
        filter_circle_id: filters.circle_id,
      }),
      ...(filters.regional_id && {
        filter_regional_id: filters.regional_id,
      }),
      ...(filters?.branch_id && {
        filter_branch_id: filters.branch_id,
      }),
    };

    const url = 'bank/animal-list'
    apiRequest({
      url,
      data: payload,
      method: "POST",
    })
      .then((res) => {
        if(res && res?.data && res?.data?.length > 0) {
          setData(res?.data);
          const modifiedData = res?.data?.map((animal) => ({
            id: animal?.id ? animal?.id : animal?.flock_id,
            tagId: animal?.animal_data.tag_no ? animal?.animal_data.tag_no : "NA",
            tagType: animal?.animal_data.tag_type,
            animalInfo:`${animal?.animal_data.category?.display_name} | ${animal?.animal_data.breed?.display_name}`,
            animalInfo1: `${ConvertMonthsToYearsMonthsDays(
              animal?.animal_data.details?.age_in_months
            )} | ${animal?.animal_data.details?.weight} Kg | ${
              animal?.animal_data.details?.no_of_calvings
            } C | ${animal?.animal_data.details?.milking_quantity} Ltr `,
            location1: `${animal?.animal_data.user_details?.farmer_data?.village_name || ''}, ${Capitalize(animal?.animal_data.user_details?.farmer_data?.hamlet_name || '')} ${animal?.animal_data.user_details?.farmer_data?.mandal_name || ''},`,
            location2: ` ${animal?.animal_data.user_details?.farmer_data?.district_name || ''}, ${
              animal?.animal_data.user_details?.farmer_data?.state_name || ''
            }, ${animal?.animal_data.user_details?.farmer_data?.pincode || ""}`,
            partner: animal?.animal_data.user_details?.farmer_data?.name || '',
            role: animal?.id?.includes("MZFR")
              ? "Farmer"
              : animal?.id?.includes("TR")
              ? "Trader"
              : "",
            userId: animal?.id,
            ve: "",
            status: animal?.animal_data.last_status,
            certificate: animal?.animal_data.certified === true ? "True" : "False",
            marketPlace: "Active",
            animal_data: animal?.animal_data,
            branch_info: animal?.branch_info || '',
          }));
          setUserAnimals({ totalCount: res?.total_count, data: modifiedData });
        }
        else {
          setUserAnimals({ totalCount: 0, data: [] });
        }
      })
      .catch((err) => {
        alert(err);
        setUserAnimals({ totalCount: 0, data: [] });
      });
  };

  const handleEdit = useCallback((data) => {
    setCurrentAnitraUserState(data);
    setOpenUserModal({ data: data, open: true });
  }, []);

  const clearFilters = () => {
    setFilters({
      search: "",
      state_id: "",
      circle_id: "",
      regional_id: "",
      branch_id: "",
    });
    setCircleList([])
    setRegionalList([])
    setBranchList([])
  };

  const TableDataUi = () => {
    return userAnimals?.data?.length ? (
    userAnimals?.data?.map((row, index) => (
      <TableRow key={row.id}>
        <TableCell className={styles.cell}>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.headerColor}
            fontSize={12}
          >
            {skip + index + 1}
          </Typography>
        </TableCell>
        <TableCell className={styles.cell}>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.headerColor}
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            fontSize={12}
            onClick={() => {
              navigate(
                `/b2banimal/details/${row?.id}`
              );
            }}
          >
            {row.id}
          </Typography>
        </TableCell>

        <TableCell className={styles.cell}>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.animalInfo}
          </Typography>
          {/*<Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.animalInfo1}
          </Typography>*/}
        </TableCell>
        <TableCell className={styles.cell}>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {" "}
            {row.location1}
          </Typography>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {" "}
            {row.location2}
          </Typography>
        </TableCell>
        {/* <TableCell className={styles.cell}>
          <Typography
            fontFamily={"Poppins-Medium"}
            color={Colors.headerColor}
            fontSize={12}
            // sx={{ textDecoration: "underline", cursor: "pointer" }}
            // onClick={() => {
            //   navigate(
            //     `/user/${
            //       row?.role?.includes("Farmer") ? "farmers" : "traders"
            //     }/${row?.userId}/details/basic`
            //   );
            // }}
          >
            {" "}
            {row.partner}
          </Typography>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={"green"}
            fontSize={12}
          >
            {" "}
            {row.role}
          </Typography>
        </TableCell> */}

        <>
            <TableCell className={styles.cell}>
              <Typography
                fontFamily={"Poppins-Medium"}
                // color={Colors.headerColor}
                fontSize={13}
                // sx={{ textDecoration: "underline", cursor: "pointer" }}
                // onClick={() => {
                //   navigate("/aceDetails");
                // }}
              >
                Name: {row?.animal_data?.user_details?.farmer_data?.name ? row.animal_data.user_details.farmer_data.name : "NA"}<br/>
                Mobile: {row?.animal_data?.user_details?.farmer_data?.mobile ? row.animal_data.user_details.farmer_data.mobile : "NA"}<br/>
                {/*Email: {row?.animal_data?.user_details?.farmer_data?.email ? row.animal_data.user_details.farmer_data.email : "NA"}<br/>*/}
                {/*Gender: {row?.animal_data?.user_details?.farmer_data?.gender ? row.animal_data.user_details.farmer_data.gender : "NA"}<br/>
                Owner Type: {row?.animal_data?.user_details?.owner_type ? row.animal_data.user_details.owner_type : "NA"}<br/>*/}
                {/*Social Status: {row?.animal_data?.user_details?.social_status ? row?.animal_data.user_details.social_status : "NA"}<br/>*/}
                {/*Landholding: {row?.animal_data?.user_details?.landholding ? row?.animal_data.user_details.landholding : "NA"}*/}
              </Typography>
            </TableCell>
            <TableCell className={styles.cell}>
              <Typography
                fontFamily={"Poppins-Medium"}
                color={Colors.textColor}
                fontSize={13}
                // sx={{ textDecoration: "underline", cursor: "pointer" }}
                // onClick={() => {
                //   navigate("/aceDetails");
                // }}
              >
                {row.branch_info}
              </Typography>
            </TableCell>
            {/* <TableCell className={styles.cell}>
              <Typography
                fontFamily={"Poppins-Regular"}
                color={Colors.textColor}
                fontSize={12}
              >
                {" "}
                {row.status}
              </Typography>
            </TableCell> */}
            {/* <TableCell className={styles.cell}>
              <Typography
                fontFamily={"Poppins-Regular"}
                color={Colors.headerColor}
                fontSize={12}
              >
                {" "}
                {row.certificate}
              </Typography>
            </TableCell> */}
            {/* <TableCell className={styles.cell}>
              <Typography
                fontFamily={"Poppins-Regular"}
                color={Colors.headerColor}
                fontSize={12}
              >
                {" "}
                {row.marketPlace}
              </Typography>
            </TableCell> */}

            {/*<TableCell className={styles.cell}>
              <Box
                padding={"2px 8px"}
                textAlign={"center"}
                borderRadius={"12px"}
                border={"1px solid #59981A"}
                bgcolor={"#59981A"}
                onClick={() => {
                  let images = []
                  _.each(row.animal_data.images, (elem) => {
                    let key = /[^/]*$/.exec(elem)[0]
                    if(key !== ''){
                      images.push(elem)
                    }
                  })
                  setOpenViewImageModal({ images, open: true });
                }}
              >
                <Typography
                  fontFamily={"Poppins-Regular"}
                  fontSize={"12px"}
                  color={"#fff"}
                  bgcolor={"#59981A"}
                >
                  {"View Images"}
                </Typography>
              </Box>
              
            </TableCell>*/}
          </>
      </TableRow>
    ))
    )
    : (
      <>
        <TableRow
          key={"row.id"}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          rowS
        >
          <TableCell colSpan={8} align="center">
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography>No Data Available</Typography>
            </Box>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const onClickModalClose = () => {
    setIsModalOpen(false);
  };
  const handlePageChange = (pageNumber) => {
    const newSkip = (pageNumber - 1) * limit;
    setSkip(newSkip);
  };

  useEffect(() => {
    let headers = [
      "Id,Tag Type,Tag No,Animal Category,Animal Breed,Animal Type,Animal Age,Milking Quantity,No of Calvings,Latitude,Longitude,Location,Front Image,Back Image,Right Image,Left Image,Muzzle Image,Partner Name,Partner Mobile",
    ];
  
    let animalsCSV;
  
    if (Array.isArray(userAnimalsCSV.data) && userAnimalsCSV.data.length > 0) {
      animalsCSV = userAnimalsCSV.data.reduce((acc, buyRequest) => {
        const {
          id = "NA",
          animal_data: {
            tag_no = "NA",
            tag_type = "NA",
            category = {},
            breed = {},
            type = {},
            details = {},
            other_details = {},
            images = {},
            muzzle_images = {},
            user_details = {},
          },
          registration_charges = "NA",
          receipt_number = "NA",
          ticket_number = "NA",
          blood_level = "NA",
          registration_organization = "NA",
        } = buyRequest;
  
        // Animal Details
        const animalCategory = category?.display_name || "NA";
        const animalBreed = breed?.display_name || "NA";
        const animalType = type?.display_name || "NA";
  
        // Animal Stats
        const ageInMonths = details?.age_in_months || "NA";
        const weight = details?.weight || "NA";
        const milkingQuantity = details?.milking_quantity || "NA";
        const noOfCalvings = details?.no_of_calvings || "NA";
        const latitude = details?.latitude || "NA";
        const longitude = details?.longitude || "NA";
  
        // Other Details
        const otherDetails = `Teeth: ${other_details?.teeth_count || "NA"} | Rings: ${other_details?.no_of_rings || "NA"}`;
  
        // User Details
        const userName = user_details?.farmer_data?.name || "NA";
        const userMobile = user_details?.farmer_data?.mobile || "NA";
        const userLocation = [
          user_details?.farmer_data?.village_name || "NA",
          user_details?.farmer_data?.mandal_name || "NA",
          user_details?.farmer_data?.district_name || "NA",
          user_details?.farmer_data?.state_name || "NA",
        ]
          .filter((part) => part !== "NA")
          .join(", ");
  
        // Images
        const animalImages = Object.values(images || {})
          .filter(Boolean)
          .join(" | ") || "NA";
        const muzzleImages = Object.values(muzzle_images || {})
          .filter(Boolean)
          .join(" | ") || "NA";
  
        // Append data row
        acc.push(
          [
            escapeCSVField(id),
            escapeCSVField(tag_type),
            escapeCSVField(tag_no),
            escapeCSVField(animalCategory),
            escapeCSVField(animalBreed),
            escapeCSVField(animalType),
            escapeCSVField(`Age: ${ageInMonths} months`),
            escapeCSVField(`${milkingQuantity} L milk`),
            escapeCSVField(`${noOfCalvings} calvings`),
            escapeCSVField(latitude),
            escapeCSVField(longitude),
            escapeCSVField(userLocation),
            escapeCSVField(/[^/]*$/.exec(images.front_image)[0] !== '' ? images.front_image : ''),
            escapeCSVField(/[^/]*$/.exec(images.back_image)[0] !== '' ? images.back_image : ''),
            escapeCSVField(/[^/]*$/.exec(images.right_image)[0] !== '' ? images.right_image : ''),
            escapeCSVField(/[^/]*$/.exec(images.left_image)[0] !== '' ? images.left_image : ''),
            escapeCSVField(/[^/]*$/.exec(images.muzzle_image1)[0] !== '' ? images.muzzle_image1 : ''),
            escapeCSVField(userName),
            escapeCSVField(userMobile),
          ].join(",")
        );
  
        return acc;
      }, []);
  
      // Download CSV
      downloadFile({
        data: [...headers, ...animalsCSV].join("\n"),
        fileName: "BankAnimals.csv",
        fileType: "text/csv",
      });
    }
  }, [userAnimalsCSV]);  

  const exportCSV = () => {
    setUserAnimalsCSV({ data: [], loader: true });
    // const payload = {
    //   skip: skip,
    //   limit: 1000000000,
    // };
    const payload = {
      skip: skip,
      limit: 1000000000,
      currentRole: currentRole,
      branch_id: branch_id,
      ...(filters.search && {
        searchText: filters?.search,
      }),
      ...(filters.state_id && {
        filter_state_id: filters.state_id,
      }),
      ...(filters.circle_id && {
        filter_circle_id: filters.circle_id,
      }),
      ...(filters.regional_id && {
        filter_regional_id: filters.regional_id,
      }),
      ...(filters?.branch_id && {
        filter_branch_id: filters.branch_id,
      })
    };

    const url = 'bank/animal-list'

    apiRequest({
      url,
      data: payload,
      method: "POST",
    })
      .then((res) => {
        setUserAnimalsCSV({ data: res?.data, loader: false });
      })
      .catch((err) => {
        alert(err);
      });
  };

  const acceptAnimal = () => {
    apiRequest({
      url: `animal/delete-muzzle/${openAceRequestModal.data.id}`,
      method: "DELETE",
    })
      .then((res) => {
        setOpenAceRequestModal({ open: false })
        getUserAnimals(filters);
        setOpenAceRequestModal({
          data: {},
          open: false,
        });
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <Box>
      <CustomModal
        openModal={openUserModal.open}
        width={"500px"}
        // style={styles.custModel}
        handleModalClose={()=>setOpenUserModal({ open: false })}
        title={"Edit Animals"}
      >
        <AddAnimal
          onCancel={() => setOpenUserModal({ open: false })}
          roleSingular={roleSingular}
          currentState={data[ind]}
          isEdit={true}
          getUserAnimals={() =>
            getUserAnimals(filters)
          }
        />
      </CustomModal>
      <CustomDialog
        open={
          openAceRequestModal.open
        }
        onClose={() => 
          setOpenAceRequestModal({ open: false })
        }
        width={"450px"}
        title={"Delete Animal"}
      >
        <Box>
          <Typography fontSize={"14px"} fontFamily={"poppins"}>
            Are you sure you want to Delete this animal data ?
          </Typography>

          <Box
            display={"flex"}
            alignItems={"end"}
            justifyContent={"flex-end"}
            width={"100%"}
            mt={2}
            gap={"12px"}
          >
            <Box width={"25%"}>
              <CustomButton
                variant={"outlined"}
                title={`No`}
                handleButtonClick={() =>
                  setOpenAceRequestModal({ open: false })
                }
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
              />
            </Box>
            <Box width={"25%"}>
              <CustomButton
                title={`Yes`}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={acceptAnimal}
              />
            </Box>
          </Box>
        </Box>
      </CustomDialog>

      <CustomDialog
        open={
          openViewImageModal.open
        }
        onClose={() => 
          setOpenViewImageModal({ open: false })
        }
        width={"450px"}
        title={"View Animal Images"}
      >
        <Box>
          <Typography fontSize={"14px"} fontFamily={"poppins"}>
            {
              openViewImageModal?.images?.map((img, index) => (
                <img
                  src={img}
                  alt="Selected"
                  style={{ width: "150px", height: "200px", padding:'0 10px 5px 0'}}
                />
              ))
            }
          </Typography>
        </Box>
      </CustomDialog>


      <Grid
        container
        alignItems={"center"}
        justifyContent={"space-between"}
        mr={0}
      >
        <Grid item xs={4}>
          <Typography
            fontFamily={"Poppins-Medium"}
            fontSize={20}
            color={Colors.textColor}
          >
            {`Animals List`}
          </Typography>
        </Grid>
        <Grid container spacing={2} xs={8} justifyContent={"end"} gap={"20px"}>
          {userAnimalsCSV.loader ? (
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              width={"100px"}
            >
              <CustomCircularProgress size={"1rem"} />
            </Box>
          ) : (
            <Grid>
              {/* <CustomButton
                title={"Edit Animals"}
                padding={"4px 20px"}
                handleButtonClick={()=>{setIsModalOpen(true)}}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                textFontSize={14}
              /> */}
              <CustomButton
                title={"Export List"}
                padding={"4px 20px"}
                handleButtonClick={exportCSV}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                textFontSize={14}
              />
            </Grid>
          )}
        </Grid>
      </Grid>

      <Box mt={2}>
        <Card>
          
          <div className="filters-wrapper-1">
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Search</label>
                  <CInput type="text" className="filter-input1" placeholder="Search ID" onChange={handleChange('search')} value={filters.search}/>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">State</label>
                  <CSelect custom onChange={handleChange('state_id')} value={filters.state_id} className="filter-input">
                      <option value="">--Select State--</option>
                      {
                          statesList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.display_name}</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Circle</label>
                  <CSelect custom onChange={handleChange('circle_id')} value={filters.circle_id} className="filter-input">
                      <option value="">--Select Circle--</option>
                      {
                          circleList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.name}</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Regional Office</label>
                  <CSelect custom onChange={handleChange('regional_id')} value={filters.regional_id} className="filter-input">
                      <option value="">--Select Regional--</option>
                      {
                          regionalList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.name}</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                  <label className="filter-input-label">Branch</label>
                  <CSelect custom onChange={handleChange('branch_id')} value={filters.branch_id} className="filter-input">
                      <option value="">--Select Branch--</option>
                      {
                          branchList.map((e, key) => {
                              return <option key={key} value={e.id}>{e.name} ({e.code})</option>;
                          })
                      }
                  </CSelect>
              </div>
              <div className="filter-input-wrapper">
                <Grid item md={2} style={{marginTop:'15px'}}>
                  <CustomButton
                    handleButtonClick={() => clearFilters()}
                    backgroundColor={"#59981A"}
                    textColor={"#fff"}
                    title={"Clear"}
                    padding={"5px 15px"}
                  />
                </Grid>
              </div>
          </div>

          <Box mt={2}>
            <CustomTable
              headerData={dashboardHeader}
              tableData={userAnimals}
              className={styles.cell}
            >
              <TableDataUi />
            </CustomTable>
            <Box mt={2} display={"flex"} justifyContent={"right"}>
              {userAnimals.total_count > 10 && (
                <Pagination
                  totalCount={userAnimals.total_count}
                  skip={skip}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default Muzzle;